import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const FinishSetup = () => {
  const navigate = useNavigate();
  const token = sessionStorage.getItem('accessToken');

  useEffect(() => {
    const timer = setTimeout(() => {
      if (token) {
        navigate('/dashboard');
      } else {
        navigate('/login');
      }
    }, 3000);

    return () => clearTimeout(timer);
  }, [navigate, token]);

  return (
    <div className="flex items-center h-[80%] justify-center">
      <div className="text-center">
        <h1 className="text-3xl text-[#111827] mb-4 !font-karla font-bold">
          Creating your account...
        </h1>

        <p className="text-gray-600 text-lg mb-12">
          This will only take a few seconds.
        </p>

        {/* Animated dots */}
        <div className="flex items-center justify-center space-x-3">
          <div className="dot-animation dot-1"></div>
          <div className="dot-animation dot-2"></div>
          <div className="dot-animation dot-3"></div>
        </div>
      </div>

      <style>{`
        .dot-animation {
          width: 16px;
          height: 16px;
          background-color: #FF643D;
          border-radius: 50%;
          animation: bounce 1.5s ease-in-out infinite;
          transform-origin: center center;
        }

        .dot-1 {
          animation-delay: 0s;
        }

        .dot-2 {
          animation-delay: 0.2s;
        }

        .dot-3 {
          animation-delay: 0.4s;
        }

        @keyframes bounce {
          0%,
          80%,
          100% {
            transform: translateY(0);
          }
          40% {
            transform: translateY(-18px);
          }
        }
      `}</style>
    </div>
  );
};

export default FinishSetup;
